import { Navigate } from "react-router-dom";
import RecepionNav from "../../pages/Dashboard/Reception/RecepionNav";
import ReceptionIndex from "../../pages/Dashboard/Reception/ReceptionIndex";
import NewPatient from "../../pages/Dashboard/Reception/NewPatient/NewPatient";
import PatientList from "../../pages/Dashboard/Reception/PatientList/PatientList";
import Appointments2 from "../../pages/Dashboard/Reception/Appointments2/Appointments2";
import PatientReferral from "../../pages/Dashboard/Reception/PatientReferral/PatientReferral";
import Expenses from "../../pages/Dashboard/Finance/Expenses/Expenses";
import ExpensesList from "../../pages/Dashboard/Finance/Expenses/ExpensesList";
import TicketingNav from "../../pages/Dashboard/Ticketing/TicketingNav";
import TicketList from "../../pages/Dashboard/Ticketing/TicketList";
import TicketCreate from "../../pages/Dashboard/Ticketing/TicketCreate";
import TicketView from "../../pages/Dashboard/Ticketing/TicketView";
import QueueList from "../../pages/Dashboard/Ticketing/QueueList/QueueList";
import EncounterTimeline from "../../pages/Dashboard/Ticketing/EncounterTimeline";
import ApprovalRequestList from "../../pages/Dashboard/Ticketing/ApprovalRequestList";
import ReceptionReturnMedicine from "../../pages/Dashboard/Reception/ReturnMedicine/ReceptionReturnMedicine";

const receptionRoutes = {
  path: "/reception",
  element: <RecepionNav />,
  children: [
    { path: "/reception", element: <ReceptionIndex /> },
    { path: "/reception/new-patient", element: <NewPatient /> },
    { path: "/reception/patient-list", element: <PatientList /> },
    { path: "/reception/patient-referral", element: <PatientReferral /> },
    { path: "/reception/appointments", element: <Appointments2 /> },
    {
      path: "/reception/ticketing",
      element: <TicketingNav />,
      children: [
        {
          index: true,
          element: <Navigate to="/reception/ticketing/tickets" replace />,
        },
        {
          path: "tickets",
          element: <TicketList />,
        },
        {
          path: "tickets/new",
          element: <TicketCreate />,
        },
        {
          path: "tickets/:id",
          element: <TicketView />,
        },
        {
          path: "queue",
          element: <QueueList />,
        },
        {
          path: "encounters",
          element: <EncounterTimeline />,
        },
        {
          path: "encounters/patient/:patientId",
          element: <EncounterTimeline />,
        },
        {
          path: "approvals",
          element: <ApprovalRequestList />,
        },
      ],
    },
    {
      path: "/reception/payment-collection",
      element: <Navigate to="/finance/payment-collection" replace />,
    },
    {
      path: "/reception/collect-prescription-fees",
      element: <Navigate to="/finance/payment-collection" replace />,
    },
    {
      path: "/reception/collect-medicine-order-fees",
      element: <Navigate to="/finance/medicine-payment" replace />,
    },
    {
      path: "/reception/collect-dental-fees",
      element: <Navigate to="/finance/fees-collection/dental" replace />,
    },
    {
      path: "/reception/collect-dental-fees/add",
      element: <Navigate to="/finance/fees-collection/dental/add" replace />,
    },
    {
      path: "/reception/collect-beauty-fees",
      element: <Navigate to="/finance/fees-collection/beauty" replace />,
    },
    {
      path: "/reception/collect-beauty-fees/add",
      element: <Navigate to="/finance/fees-collection/beauty/add" replace />,
    },
    {
      path: "/reception/collect-ht-patient-fees",
      element: <Navigate to="/finance/fees-collection/ht-patient" replace />,
    },
    {
      path: "/reception/collect-ht-patient-fees/add",
      element: <Navigate to="/finance/fees-collection/ht-patient/add" replace />,
    },
    {
      path: "/reception/collect-ultrasound-fees",
      element: <Navigate to="/finance/fees-collection/ultrasound" replace />,
    },
    {
      path: "/reception/collect-ultrasound-fees/add",
      element: <Navigate to="/finance/fees-collection/ultrasound/add" replace />,
    },
    {
      path: "/reception/collect-xray-fees",
      element: <Navigate to="/finance/fees-collection/xray" replace />,
    },
    {
      path: "/reception/collect-xray-fees/add",
      element: <Navigate to="/finance/fees-collection/xray/add" replace />,
    },
    {
      path: "/reception/collect-laboratory-fees",
      element: <Navigate to="/finance/fees-collection/laboratory" replace />,
    },
    {
      path: "/reception/collect-echo-fees",
      element: <Navigate to="/finance/fees-collection/echo" replace />,
    },
    {
      path: "/reception/collect-echo-fees/add",
      element: <Navigate to="/finance/fees-collection/echo/add" replace />,
    },
    {
      path: "/reception/collect-emergency-fees",
      element: <Navigate to="/finance/fees-collection/emergency" replace />,
    },
    {
      path: "/reception/collect-ipd-fees",
      element: <Navigate to="/finance/fees-collection/ipd" replace />,
    },
    {
      path: "/reception/collect-icu-fees",
      element: <Navigate to="/finance/fees-collection/icu" replace />,
    },
    {
      path: "/reception/return-medicine",
      element: <ReceptionReturnMedicine />,
    },

    { path: "/reception/add-expense", element: <Expenses /> },
    { path: "/reception/expenses", element: <ExpensesList /> },
  ],
};

export default receptionRoutes;
